var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsersIcon = exports.SafeBuyIcon = exports.MoneyIcon = exports.DealIcon = exports.CreditCardIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _olxIcons = require("@olxbr/olx-icons");
var _jsxRuntime = require("react/jsx-runtime");
var _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/ModalExitChat/Icons.js";
var CreditCardIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  size: "small",
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.CreditCard, {
    color: "var(--color-feedback-error-110)"
  }),
  bgColor: "--color-feedback-error-80",
  marginRight: "--spacing-1"
});
exports.CreditCardIcon = CreditCardIcon;
var DealIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  size: "small",
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.Deal, {
    color: "var(--color-feedback-error-110)"
  }),
  bgColor: "--color-feedback-error-80",
  marginRight: "--spacing-1"
});
exports.DealIcon = DealIcon;
var MoneyIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  size: "small",
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.Money, {
    color: "var(--color-feedback-error-110)"
  }),
  bgColor: "--color-feedback-error-80",
  marginRight: "--spacing-1"
});
exports.MoneyIcon = MoneyIcon;
var SafeBuyIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  size: "small",
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.SafeBuy, {
    color: "var(--color-feedback-error-110)"
  }),
  bgColor: "--color-feedback-error-80",
  marginRight: "--spacing-1"
});
exports.SafeBuyIcon = SafeBuyIcon;
var UsersIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  size: "small",
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.Users, {
    color: "var(--color-feedback-error-110)"
  }),
  bgColor: "--color-feedback-error-80",
  marginRight: "--spacing-1"
});
exports.UsersIcon = UsersIcon;